import dateHandler from './dateHandler'
import { updateProduct } from '../api/admin'
import moment from 'moment'
import { DateTime } from 'luxon'
import timeHandler from './timeHandler'

// Formats previously stored product data to display in product form format
const formatProductForForm = (item) => {
  let hold = item.metadata
  let tmp = Object.assign(
    {
      price: (item.priceInfo.unit_amount / 100).toString(),
      prodId: item.id,
      priceId: item.priceInfo.id,
      cap: item.info.cap
    },
    hold
  )

  tmp.startTime = item.metadata.startTime + ':' + item.metadata.startTimeMinute
  tmp.endTime = item.metadata.endTime + ':' + item.metadata.endTimeMinute
  // set date
  if (!item.info.selectDates || item.info.selectDates.length == 0) {
    tmp.selectDates = dateHandler.getConsecutiveDates(
      item.metadata.startDate,
      item.metadata.endDate
    )
  } else {
    tmp.selectDates = item.info.selectDates.map((date) =>
      dateHandler.getDateTimeObj(date).toLocaleString(DateTime.DATE_MED)
    )
  }
  tmp.startDate = dateHandler.getDateTimeObj(item.metadata.startDate)
  tmp.endDate = dateHandler.getDateTimeObj(item.metadata.endDate)

  tmp.ageMin = item.info.ageMin
  tmp.ageMax = item.info.ageMax

  //product form needs instructor Ids only
  tmp.instructors = item.instructors.map((instructor) => {
    return instructor._id
  })

  //Product form needs to check if students have been enrolled
  tmp.students = item.info.students
  tmp.seasonCode = item.info.seasonCode

  return tmp
}
const formatProductForSave = (product, course, uID) => {
  let tmpProduct = { ...product }
  // Format selectDates
  tmpProduct.selectDates = tmpProduct.selectDates.map((date) => {
    let tmp = dateHandler.getDateTimeObj(date)
    return tmp.toUnixInteger().toString() //Save as String to be consistent with Stripe
  })

  tmpProduct.startDate = dateHandler.getDateTimeObj(tmpProduct.startDate)
  tmpProduct.endDate = dateHandler.getDateTimeObj(tmpProduct.endDate)

  // Format name String
  let formattedStartDate = dateHandler.formatDate(tmpProduct.startDate)
  let formattedEndDate = dateHandler.formatDate(tmpProduct.endDate)
  let nameString = `${tmpProduct.locationName} ${tmpProduct.courseName} ${formattedStartDate}-${formattedEndDate} ${tmpProduct.startTime}-${tmpProduct.endTime}`
  tmpProduct.nameString = nameString

  // Convert to Unix string to save in Stripe
  tmpProduct.startDate = tmpProduct.startDate.toUnixInteger().toString()
  tmpProduct.endDate = tmpProduct.endDate.toUnixInteger().toString()

  tmpProduct.price = (tmpProduct.price * 100).toFixed(0)
  tmpProduct.uID = uID
  tmpProduct.ageMin = parseInt(course.age.min)
  tmpProduct.ageMax = parseInt(course.age.max)
  tmpProduct.stripeID = tmpProduct.prodId
  return tmpProduct
}
const update = async (tmpProduct) => {
  let resp = await updateProduct(tmpProduct)
  if (resp.success) {
    resp.data.priceInfo = resp.data.price
    delete resp.data.price
    return { success: true, data: resp.data }
  } else {
    return { error: true }
  }
}

const productHandler = { formatProductForForm, formatProductForSave, update }

export default productHandler
